var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warning"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.2,
    d: "M44.5913 15.619L10.2256 74.991C9.67567 75.941 9.38568 77.0191 9.38477 78.1168C9.38386 79.2145 9.67207 80.2931 10.2204 81.244C10.7687 82.195 11.5578 82.9847 12.5083 83.5338C13.4588 84.0829 14.5371 84.372 15.6348 84.372H84.3662C85.4639 84.372 86.5423 84.0829 87.4927 83.5338C88.4432 82.9847 89.2323 82.195 89.7806 81.244C90.329 80.2931 90.6172 79.2145 90.6162 78.1168C90.6153 77.0191 90.3253 75.941 89.7754 74.991L55.4097 15.619C54.8607 14.6705 54.0719 13.8831 53.1225 13.3356C52.1731 12.7882 51.0964 12.5 50.0005 12.5C48.9046 12.5 47.8279 12.7882 46.8785 13.3356C45.9291 13.8831 45.1403 14.6705 44.5913 15.619Z",
    fill: "#5B22EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50 37.5V56.25",
    stroke: "#5B22EB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M50 75C52.5888 75 54.6875 72.9013 54.6875 70.3125C54.6875 67.7237 52.5888 65.625 50 65.625C47.4112 65.625 45.3125 67.7237 45.3125 70.3125C45.3125 72.9013 47.4112 75 50 75Z",
    fill: "#5B22EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M44.5913 15.619L10.2256 74.991C9.67567 75.941 9.38568 77.0191 9.38477 78.1168C9.38386 79.2145 9.67207 80.2931 10.2204 81.244C10.7687 82.195 11.5578 82.9847 12.5083 83.5338C13.4588 84.0829 14.5371 84.372 15.6348 84.372H84.3662C85.4639 84.372 86.5422 84.0829 87.4927 83.5338C88.4432 82.9847 89.2323 82.195 89.7806 81.244C90.329 80.2931 90.6172 79.2145 90.6162 78.1168C90.6153 77.0191 90.3253 75.941 89.7754 74.991L55.4097 15.619C54.8607 14.6705 54.0719 13.8831 53.1225 13.3356C52.1731 12.7882 51.0964 12.5 50.0005 12.5C48.9046 12.5 47.8279 12.7882 46.8785 13.3356C45.9291 13.8831 45.1403 14.6705 44.5913 15.619V15.619Z",
    stroke: "#5B22EB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.c9d140cd8b229bbe85d2e211d568ed05.svg";
export { ForwardRef as ReactComponent };